<template>
	<div class="landing-page">
<!--		<carbon-ads placement="InboxLanding"></carbon-ads>-->
		<div class="header-gradient-background">
			<div class="header">
				<img class="logo" src="@/assets/docasny_email.png"/>
				<h1>Dočasný email</h1>
				<h2>Vytvorte si dočasný email jedným klikom</h2>
			</div>
			<div class="email-selection">
				<form v-on:submit.prevent="goToInbox">
					<div class="input-box">
						<input class="input-email" name="email" aria-label="email" type="text" v-model="randomName" id="email-input"/>
						<div class="input-suffix tooltipped tooltipped-s" aria-label="Kliknite pre skopírovanie emailovej adresy" id="div-domain" data-clipboard-target="#email-input">@{{domain}}</div>
					</div>
					<div class="submit-box"><input type="submit" class="submit" value="Vytvoriť"/></div>
				</form>
			</div>
		</div>
    <div id="ad-homepage"></div>
		<div class="info-guide">
			<div class="features" style="max-width:1100px">
				<div class="feature-card">
					<h3><i class="fas fa-mail-bulk"></i>Vyhnite sa SPAMu a chráňte si súkromie</h3>
					<p>
						Môžete si vytvoriť ľubovoľný počet dočasných emailových schránok a nemusíte tak zadávať na stránkach a portáloch svoju reálnu emailovú adresu.
						Vyhnete sa tak nevyžiadanej pošte (spamu), ochránite svoje súkromie a zvýšite pohodlie, pretože novú emailovú adresu máte k dispozícií na jeden klik!
					</p>
				</div>
				<div class="feature-card">
					<h3><i class="fas fa-trash-alt"></i>Emaily sa mažú automaticky</h3>
					<p>
						Všetky prichádzajúce emaily sa automaticky po troch dňoch vymažú a vy tak po sebe nezanecháte žiadne stopy, ani hromadu zbytočného odpadu.
					</p>
				</div>
			</div>
			<div class="line-break"></div>
		</div>
	</div>
</template>
<script>
	import $ from 'jquery'
	import config from '@/../config/apiconfig.js'
	import 'normalize.css'
	import ClipboardJS from 'clipboard'

	import CarbonAds from '@/components/CarbonAds'

	export default {
		name: 'LandingPage',
		components: {
			CarbonAds: CarbonAds
		},
		data () {
			return {
				msg: 'Welcome to Your Vue.js App',
				randomName: ''
			}
		},
		mounted () {
			this.randomName = this.generateRandomName().toString()

			this.$clipboard = []

			let self = this

			this.$clipboard[0] = new ClipboardJS('#div-domain', {
				text: function (trigger) {
					if (self.randomName.includes('@' + config.domain)) {
						return self.randomName
					}
					return self.randomName + '@' + config.domain
				}
			})

			this.$clipboard[0].on('success', function (e) {
				$('#email-input').select()
				$('#div-domain').addClass('tooltipped tooltipped-s')
				$('#div-domain').attr('aria-label', 'Copied!')
				$('#div-domain').on('mouseleave', function () {
					$('#div-domain').removeClass('tooltipped tooltipped-s')
					$('#div-domain').removeAttr('aria-label')
				})
			})

      // add ad
      let scriptElement = document.createElement('script')
      scriptElement.setAttribute('src', '/ad-homepage.js')
      scriptElement.setAttribute('id', 'etargetScript199d6ca84471cbc16f6a002bebf19dbb')
      document.querySelector('#ad-homepage').appendChild(scriptElement)
		},
		beforeDestroy () {
			if (this.$clipboard !== null) {
				this.$clipboard.forEach((cb) => {
					cb.destroy()
			})
			}
		},
		computed: {
			domain () {
				return config.domain
			}
		},
		methods: {
			generateRandomName () {
				var randomWords = require('random-words')
				return randomWords({
					exactly: 1,
					wordsPerString: 2,
					separator: '-'
				}) + '-' + Math.floor(Math.random() * 90 + 10)
			},
			goToInbox () {
				this.$router.push({
					name: 'Inbox',
					params: {
						email: this.randomName
					}
				})
			},
			goToKittenRouter () {
				location.href = '/kittenrouter'
			}
		}
	}
</script>

<style lang="scss" rel="stylesheet/scss">
	@import url("https://use.fontawesome.com/releases/v5.3.1/css/all.css");
	@import "scss/landingpage.scss";
	@import "primer-tooltips/index.scss";

	.landing-navigation {
		display:flex;
		justify-content: flex-end;
		align-items: center;
		float:right;
		width: 100vw;
		height: 1rem;
		text-align: left;

		.landing-nav-main-logo {
			width:8rem;
			padding-top:7rem;
			padding-right: 4rem;
			z-index: 2;
			cursor: pointer;
		}

		.landing-nav-header {
			padding-top:6rem;
			padding-right: 3rem;
			cursor: pointer;
		}
	}

	@media only screen and (max-width:470px) {
		.landing-navigation .landing-nav-main-logo {
			padding-right: 4rem;
			width:5rem;
			z-index: 3;
		}
		.landing-nav-header {
			display: none;
		}
	}
	@media only screen and (max-width:800px){
		.landing-navigation {
			padding-top: 140px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/landingpage.vue